var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCollegeGradCap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.06 44.488c.124-1.488.633-2.68 1.232-3.13a2.128 2.128 0 0 1-1.624-2.062c0-.97.656-1.79 1.547-2.043V25.778l1.172-.447v11.922a2.128 2.128 0 0 1 1.547 2.043c0 .999-.69 1.833-1.623 2.061.601.45 1.108 1.643 1.232 3.13l.907 12.9c-.025.003-.05.007-.076.013-.717-.615-1.608-.983-2.576-.983s-1.86.368-2.576.983a.64.64 0 0 1-.076-.013l.907-12.9h.007z",
    fill: "#F6C760",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.136 26.236c-2.59-3.748-10.31-6.468-19.43-6.468-9.122 0-16.841 2.72-19.43 6.468 4.3-2.435 11.397-4.03 19.43-4.03 8.032 0 15.13 1.595 19.43 4.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4 39.757v-8.454l12.1-4.998L35 13.3 3.5 26.308l12.1 4.997v7.94c5.326-1.97 11.78-3.12 18.74-3.12 7.544 0 14.497 1.357 20.06 3.635v-.003zM35 23.652c9.107 0 16.818 2.656 19.4 6.317-4.294-2.379-11.38-3.936-19.4-3.936-8.02 0-15.106 1.557-19.4 3.936 2.585-3.66 10.293-6.317 19.4-6.317z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCollegeGradCap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-college-grad-cap.314a1770ebc8db2799fbd0657f24f458.svg";